import React from "react";
import { Input, Icon, Form } from "antd";

const FormInput = ({ field, onChangeUploadGroup, getFieldDecorator, label, value }) => {

  const inputValue = value ? Object.assign(value) : null;
  
  return (
    <Form.Item label={label && label}>
      {getFieldDecorator(field.name, {
        initialValue: value ? inputValue[field.name] : null,
        rules: [{ required: field.required, message: field.message }],
      })(
        <Input
          prefix={
            <Icon type={field.icon} style={{ color: "rgba(0,0,0,.25)" }} />
          }
          type={field.type}
          size={field.size}
          placeholder={field.placeholder}
          style={{ border: 0 }}
          onChange={onChangeUploadGroup}
        />
      )}
    </Form.Item>
  );
};

export default FormInput;
